// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__nu53X","spin":"Loading_spin__yTYiX"};